import React from "react";
import style from "css/hotdesking.module.css";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";

function Loading() {
  return (
    <section className={style.loading}>
      <Spin indicator={<LoadingOutlined spin />} />
    </section>
  );
}

export default Loading;
